var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import useService from "../../../Hooks/useService";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import SecondaryNavButton from "../../../UI/SecondaryNav/SecondaryNavButton";
import ContentLayout from "../../../Layout/ContentLayout";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import { BasicFormFormat } from "../../../UI/FormFormat/FormFormat";
import { getCourseSectionDetailPath } from "./CourseSectionRoutes";
import CourseSectionService from "../../../../Services/CourseSection.service";
import CourseSectionForm, { getCourseSectionSaveRequest, } from "../../../Presentational/CourseSection/CourseSectionForm";
import PageTitle from "../../../UI/PageTitle/PageTitle";
const CourseSectionEdit = () => {
    const saveButtonRef = useRef(null);
    const history = useHistory();
    const [courseSectionState, loadCourseSection] = useService(CourseSectionService.get);
    const params = useParams();
    const id = params.id;
    React.useEffect(() => {
        if (id) {
            loadCourseSection(id);
        }
    }, [id, loadCourseSection]);
    return (_jsx(SecondaryNavLayout, { nav: _jsxs("div", { className: "d-flex", children: [_jsx(SecondaryNavButton, { icon: "save", label: "Save", title: "Save", iconType: "fas", onClick: () => {
                        var _a;
                        (_a = saveButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    } }), _jsx(Link, { to: getCourseSectionDetailPath(id), title: "Cancel", tabIndex: -1, children: _jsx(SecondaryNavButton, { icon: "times", label: "Cancel", title: "Cancel", iconType: "fas" }) })] }), children: _jsxs(ContentLayout, { paddingTop: true, paddingBottom: true, whiteBackground: true, children: [_jsx(PageTitle, { className: "pb-2", children: "Edit Course Section" }), _jsx(ServiceResult, { state: courseSectionState, children: (courseSection) => (_jsx(BasicFormFormat, { saveButtonRef: saveButtonRef, handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                            return CourseSectionService.save(getCourseSectionSaveRequest(formState)).then((response) => {
                                history.push(getCourseSectionDetailPath(response.id));
                            });
                        }), defaultValue: {
                            id: courseSection.id,
                            instructor: courseSection.mainInstructor,
                            courseSectionStatus: courseSection.courseSectionStatus,
                            online: courseSection.online,
                            lmsOverridden: courseSection.lmsOverridden,
                            lmsId: courseSection.lmsId,
                            lmsHasGradeableAssignment: courseSection.lmsHasGradeableAssignment,
                            lmsHasConfiguredTotalColumn: courseSection.lmsHasConfiguredTotalColumn,
                            lmsIdIsPartOfMultiId: courseSection.lmsIdIsPartOfMultiId,
                            sisOverridden: courseSection.sisOverridden,
                        }, errorMessagePosition: "top", hideButtons: true, children: _jsx(CourseSectionForm, { courseSection: courseSection }) })) })] }) }));
};
export default CourseSectionEdit;
